export function ListItemFirstIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 1.875C5.5125 1.875 1.875 5.5125 1.875 10C1.875 14.4875 5.5125 18.125 10 18.125C14.4875 18.125 18.125 14.4875 18.125 10C18.125 5.5125 14.4875 1.875 10 1.875ZM11.0981 14.085H9.555V8.26937C8.99188 8.795 8.3275 9.18375 7.5625 9.43625V8.04C7.965 7.90813 8.4025 7.6575 8.87438 7.28875C9.34625 6.92 9.67 6.49 9.84625 5.99875H11.0981V14.085Z"
        fill="#475569"
      />
    </svg>
  );
}
